function removeDotsAndBars(value) {
    if (value) {
        const hasNumber = /[0-9]/.test(value)
        // If has any number, them remove dots and bars.
        if (hasNumber) {
            const stringValue = value.toString()
            const regex = /[()-.,/%]/ig
            return stringValue.replace(regex, '')
        }
        return value
    }
}

export default removeDotsAndBars
